import Vue from 'vue';
import Router from 'vue-router';
import { getView } from '@/lib/utils';
import routes from './routes';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: getView('layouts/LayoutDefault'),
      children: routes,
    },
  ],
});
